/**
 * Ghost stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const ghostStickersPack: ToilePack = {
    slug: 'ghost-stickers',
    category: 'sticker',
    name: 'Ghost stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'wave', label: 'Waving ghost', subject: 'a little ghost waving with a blush'},
        {key: 'tea', label: 'Ghost with tea', subject: 'a ghost holding a cup of tea'},
        {key: 'peek', label: 'Peeking ghost', subject: 'a ghost peeking out from under a sheet'},
    ],
    styles: [
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'bold', label: 'Bold cartoon', style: 'bold cartoon sticker, thick black outlines, bright flat fills, slight gloss', palette: 'Bright saturated primaries with black outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'doodle', label: 'Hand-drawn', style: 'hand-drawn marker doodle sticker, loose line, flat wash fills', palette: 'Two or three muted colours with a black line', framing: 'Each sticker isolated with a thin white die-cut border on a plain ground'},
    ],
    directions: ['a pumpkin ghost instead', 'a whole sticker sheet', 'in pastel colors'],
    directionHint: 'try: a pumpkin ghost instead',
    seo: {
        title: 'Ghost Stickers: Waving, With Tea, Peeking',
        metaDescription: 'Nine cute ghost stickers — a waving ghost, a ghost with tea, a ghost peeking from a sheet — in kawaii, bold cartoon, and hand-drawn styles.',
        h1: 'Ghost stickers: waving ghost, ghost with tea, peeking ghost',
        tagline: 'Nine stickers, three ghost moments, three styles each.',
        intro: 'A little ghost waving with a blush, a ghost holding a cup of tea, and a ghost peeking out from under a sheet — three cute ghost stickers, die-cut and ready to print. Each rendered kawaii, bold cartoon, and loose hand-drawn. Ask for a different colour ghost, a haunted-house scene, or a group-of-ghosts composition, and the same three styles carry it.',
        useCases: [
            'a laptop or water bottle',
            'a planner or journal page',
            'a phone case sticker sheet',
            'a Halloween party favour',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine cute ghost stickers — a waving ghost, a ghost with tea, and a peeking ghost — in kawaii, bold cartoon, and hand-drawn finishes.'},
            {q: 'Can I get a different colour ghost or scene?', a: 'Yes — the direction field takes any variation, including a different colour ghost, a haunted-house scene, or a group-of-ghosts composition.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
            {q: 'Is this scary imagery?', a: 'No — these are cute, kawaii-style ghosts, not horror imagery.'},
        ],
    },
}
